/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

export class AndroidOSBuildProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AndroidOSBuildProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAndroidOSBuildProto(
    bb: flatbuffers.ByteBuffer,
    obj?: AndroidOSBuildProto,
  ): AndroidOSBuildProto {
    return (obj || new AndroidOSBuildProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAndroidOSBuildProto(
    bb: flatbuffers.ByteBuffer,
    obj?: AndroidOSBuildProto,
  ): AndroidOSBuildProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AndroidOSBuildProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  buildId(): string | null;
  buildId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildDisplay(): string | null;
  buildDisplay(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildDisplay(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildProduct(): string | null;
  buildProduct(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildProduct(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildDevice(): string | null;
  buildDevice(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildDevice(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildBoard(): string | null;
  buildBoard(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildBoard(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildManufacturer(): string | null;
  buildManufacturer(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildManufacturer(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildBrand(): string | null;
  buildBrand(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildBrand(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildModel(): string | null;
  buildModel(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildModel(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildHardware(): string | null;
  buildHardware(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildHardware(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildSerial(): string | null;
  buildSerial(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildSerial(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildVersionIncremental(): string | null;
  buildVersionIncremental(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildVersionIncremental(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildVersionRelease(): string | null;
  buildVersionRelease(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildVersionRelease(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  buildVersionSdk(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  buildVersionCodename(): string | null;
  buildVersionCodename(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  buildVersionCodename(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  supportedAbis(index: number): string;
  supportedAbis(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  supportedAbis(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  supportedAbisLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startAndroidOSBuildProto(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addBuildId(builder: flatbuffers.Builder, buildIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, buildIdOffset, 0);
  }

  static addBuildDisplay(builder: flatbuffers.Builder, buildDisplayOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, buildDisplayOffset, 0);
  }

  static addBuildProduct(builder: flatbuffers.Builder, buildProductOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, buildProductOffset, 0);
  }

  static addBuildDevice(builder: flatbuffers.Builder, buildDeviceOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, buildDeviceOffset, 0);
  }

  static addBuildBoard(builder: flatbuffers.Builder, buildBoardOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, buildBoardOffset, 0);
  }

  static addBuildManufacturer(
    builder: flatbuffers.Builder,
    buildManufacturerOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, buildManufacturerOffset, 0);
  }

  static addBuildBrand(builder: flatbuffers.Builder, buildBrandOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, buildBrandOffset, 0);
  }

  static addBuildModel(builder: flatbuffers.Builder, buildModelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, buildModelOffset, 0);
  }

  static addBuildHardware(builder: flatbuffers.Builder, buildHardwareOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, buildHardwareOffset, 0);
  }

  static addBuildSerial(builder: flatbuffers.Builder, buildSerialOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, buildSerialOffset, 0);
  }

  static addBuildVersionIncremental(
    builder: flatbuffers.Builder,
    buildVersionIncrementalOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, buildVersionIncrementalOffset, 0);
  }

  static addBuildVersionRelease(
    builder: flatbuffers.Builder,
    buildVersionReleaseOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(11, buildVersionReleaseOffset, 0);
  }

  static addBuildVersionSdk(builder: flatbuffers.Builder, buildVersionSdk: number) {
    builder.addFieldInt32(12, buildVersionSdk, 0);
  }

  static addBuildVersionCodename(
    builder: flatbuffers.Builder,
    buildVersionCodenameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, buildVersionCodenameOffset, 0);
  }

  static addSupportedAbis(builder: flatbuffers.Builder, supportedAbisOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, supportedAbisOffset, 0);
  }

  static createSupportedAbisVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSupportedAbisVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endAndroidOSBuildProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createAndroidOSBuildProto(
    builder: flatbuffers.Builder,
    buildIdOffset: flatbuffers.Offset,
    buildDisplayOffset: flatbuffers.Offset,
    buildProductOffset: flatbuffers.Offset,
    buildDeviceOffset: flatbuffers.Offset,
    buildBoardOffset: flatbuffers.Offset,
    buildManufacturerOffset: flatbuffers.Offset,
    buildBrandOffset: flatbuffers.Offset,
    buildModelOffset: flatbuffers.Offset,
    buildHardwareOffset: flatbuffers.Offset,
    buildSerialOffset: flatbuffers.Offset,
    buildVersionIncrementalOffset: flatbuffers.Offset,
    buildVersionReleaseOffset: flatbuffers.Offset,
    buildVersionSdk: number,
    buildVersionCodenameOffset: flatbuffers.Offset,
    supportedAbisOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    AndroidOSBuildProto.startAndroidOSBuildProto(builder);
    AndroidOSBuildProto.addBuildId(builder, buildIdOffset);
    AndroidOSBuildProto.addBuildDisplay(builder, buildDisplayOffset);
    AndroidOSBuildProto.addBuildProduct(builder, buildProductOffset);
    AndroidOSBuildProto.addBuildDevice(builder, buildDeviceOffset);
    AndroidOSBuildProto.addBuildBoard(builder, buildBoardOffset);
    AndroidOSBuildProto.addBuildManufacturer(builder, buildManufacturerOffset);
    AndroidOSBuildProto.addBuildBrand(builder, buildBrandOffset);
    AndroidOSBuildProto.addBuildModel(builder, buildModelOffset);
    AndroidOSBuildProto.addBuildHardware(builder, buildHardwareOffset);
    AndroidOSBuildProto.addBuildSerial(builder, buildSerialOffset);
    AndroidOSBuildProto.addBuildVersionIncremental(builder, buildVersionIncrementalOffset);
    AndroidOSBuildProto.addBuildVersionRelease(builder, buildVersionReleaseOffset);
    AndroidOSBuildProto.addBuildVersionSdk(builder, buildVersionSdk);
    AndroidOSBuildProto.addBuildVersionCodename(builder, buildVersionCodenameOffset);
    AndroidOSBuildProto.addSupportedAbis(builder, supportedAbisOffset);
    return AndroidOSBuildProto.endAndroidOSBuildProto(builder);
  }
}
